import ApiService from '../../api.service';

const BASE_URL = '/demo-tickets';

export const DemoCarsService = {
  /**
   * Lấy danh sách xe demo với phân trang và lọc
   * @param {Object} params - Các tham số lọc và phân trang
   * @returns {Promise}
   */
  getList(params) {
    return ApiService.query(BASE_URL, { params });
  },

  /**
   * Lấy thông tin chi tiết của một xe demo
   * @param {string} id - ID của xe demo
   * @returns {Promise}
   */
  getById(id) {
    return ApiService.get(`${BASE_URL}/${id}`);
  },

  /**
   * Tạo mới xe demo
   * @param {Object} data
   * @returns {Promise}
   */
  create(data) {
    return ApiService.post(BASE_URL, data);
  },

  /**
   * Cập nhật thông tin xe demo
   * @param {string} id - ID của xe demo
   * @param {Object} data
   * @returns {Promise}
   */
  update(id, data) {
    return ApiService.patch(`${BASE_URL}/${id}`, data);
  },

  /**
   * Xóa xe demo
   * @param {string} id - ID của xe demo
   * @returns {Promise}
   */
  delete(id) {
    return ApiService.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Xuất danh sách xe demo ra Excel
   * @param {Object} params - Các tham số lọc
   * @returns {Promise}
   */
  exportExcel(params) {
    return ApiService.query(`${BASE_URL}/export-excel`, {
      params,
      responseType: 'blob',
    });
  },

  /**
   * Tìm kiếm thông tin sản phẩm theo mã sản phẩm
   * @param {string} productCode - Mã sản phẩm
   * @returns {Promise}
   */
  lookupByProductCode(productCode) {
    return ApiService.get(`products/lookup/${productCode}`);
  },

  /**
   * Tìm kiếm thông tin sản phẩm theo số khung
   * @param {Object} params - Số khung
   * @param {string} params.chassisNumber - Số khung
   * @param {string} params.productName - Tên sản phẩm
   * @param {string} params.productCode - Mã sản phẩm
   * @param {string} params.engineNumber - Số máy
   * @param {number} params.page - Trang hiện tại
   * @param {number} params.limit - Số lượng bản ghi trên một trang
   * @param {string} params.storeId - ID của cửa hàng
   * @returns {Promise<Object>}
   */
  lookupByChassis(
    params = {
      chassisNumber: '',
      productName: '',
      productCode: '',
      engineNumber: '',
      storeId: '',
      page: 1,
      limit: 10,
    },
  ) {
    return ApiService.query(`${BASE_URL}/lookup-by-chassis`, { params });
  },
};
